export function sbmProgramsLPM1(extraHeight = 40) {
    'use strict';
    const lpm1Card = $('.sbm-programs-lpm1 .lpm1_card');
    const $container = $("html,body");
    var headerHeight = $('.mtpc_header').height() + extraHeight;
    const searchParams = new URLSearchParams(window.location.search);
    if (lpm1Card.length > 0) {
        lpm1Card.each(function () {
            const scrollToClass = $(this).attr('data-scrollTo');
            const $scrollTo = $(scrollToClass);
            $(this).on('click', function () {
                $container.animate({scrollTop: $scrollTo.offset().top - headerHeight}, 800);
            });
        });
    }
    if (searchParams.has('navigateTo')) {
        const scrollToClass = '.' + searchParams.get('navigateTo');
        const $scrollTo = $(scrollToClass);
        if ($scrollTo.length) {
            $container.animate({scrollTop: $scrollTo.offset().top - headerHeight}, 800);
        }
    }
}
